import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ITicketResponse } from '../ticket-response';
import { ticketResponseSchema } from '../ticket-response';
import type { IAddTicketMessageRequest } from './add-ticket-message-request';

export async function addTicketMessageApi(
  id: number,
  body: IAddTicketMessageRequest,
): Promise<IValidatedResponse<ITicketResponse>> {
  return postRequest<ITicketResponse>({
    path: `/ticket/${id}/messages`,
    body,
    schema: ticketResponseSchema,
  });
}
